import { CaretDownOutlined, LogoutOutlined } from '@ant-design/icons';
import { Avatar, Button, Dropdown, Menu } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import React from 'react';
import { clearCurrentUser } from '../../actions/UserAction';
import { toggleZopim } from '../../actions/ZopimAction';
import { primaryColor, primaryLighterColor } from '../../constants/COLORS';
import { LOGO } from '../../constants/CONSTANTS';
import CartIcon from '../../containers/Cart/CartIcon';
import useWindowDimension from '../../utils/useWindowDimension';
import NotificationHeader from '../NotificationHeader';
import Translate from '../Translate';

const DashboardHeader = () => {
  const fullName = useSelector((state: AppState) => state.user.full_name);
  const zopim = useSelector((state: AppState) => state.zopim);
  const dispatch = useDispatch();
  const { isSmallScreen } = useWindowDimension();

  return (
    <Wrapper>
      <div className="logo">
        {isSmallScreen && (
          <Link to="/">
            <img style={{ height: 25 }} src={LOGO} alt="main-logo" />
          </Link>
        )}
      </div>
      <div className="menu-list">
        <Button
          type="link"
          size="small"
          style={{ marginRight: 10, fontSize: '13px' }}
          onClick={() => dispatch(toggleZopim())}
        >
          {zopim?.showZendesk ? 'Hide Help Widget' : 'Show Help Widget'}
        </Button>
        <CartIcon />
        <NotificationHeader style={{ marginLeft: 10 }} />

        <div style={{ marginLeft: '10px' }}>
          <Dropdown
            trigger={['click']}
            overlay={
              <Menu mode="vertical">
                <Menu.Item>
                  <div
                    onClick={() => {
                      dispatch(clearCurrentUser());
                      localStorage.removeItem('sa-token');
                    }}
                  >
                    <LogoutOutlined /> <Translate id="logout" />
                  </div>
                </Menu.Item>
              </Menu>
            }
            placement="bottomLeft"
          >
            <div style={{ cursor: 'pointer' }}>
              <Avatar
                style={{
                  color: primaryColor,
                  backgroundColor: primaryLighterColor,
                }}
              >
                {fullName ? fullName[0] : ''}
              </Avatar>
              <span style={{ margin: '0px 5px' }}>{fullName}</span>
              <CaretDownOutlined />
            </div>
          </Dropdown>
        </div>
      </div>

      {/* <Col sm={24} lg={14} /> */}
      {/* <RightCol sm={24} lg={10}>
        <Row align="middle" style={{ cursor: 'pointer' }}>
          <Col span={19} style={{ textAlign: 'right' }}>
            <CartIcon />
            <StyledLink to="/">{fullName}</StyledLink>
          </Col>
          <Dropdown
            trigger={['click']}
            overlay={
              <Menu mode="vertical">
                <Menu.Item>
                  <div
                    onClick={() => {
                      dispatch(clearCurrentUser());
                      localStorage.removeItem('sa-token');
                    }}
                  >
                    <LogoutOutlined /> <Translate id="logout" />
                  </div>
                </Menu.Item>
              </Menu>
            }
            placement="bottomLeft"
          >
            <AvatarCol span={5}>
              <Avatar
                style={{
                  color: primaryColor,
                  backgroundColor: primaryLighterColor,
                }}
              >
                {fullName ? fullName[0] : ''}
              </Avatar>
              <CaretDownOutlined />
            </AvatarCol>
          </Dropdown>
        </Row>
      </RightCol> */}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  background: #f1f1f1;
  border-bottom: 1px solid #e5e5e5;
  height: auto;
  padding: 10px 20px;
  display: flex;
  justify-content: space-between;

  .menu-list {
    display: flex;
    align-items: center;
  }
`;

// const RightCol = styled(Col)`
//   text-align: right;
// `;

// const StyledLink = styled(Link)`
//   font-weight: 600;
//   text-decoration: none;
//   margin: 0 15px;
// `;
// const AvatarCol = styled(Col)`
//   padding-top: 5px;
//   text-align: center;
// `;

export default DashboardHeader;
